

export const langConfigList = [
  { label: '中文', value: 'zh-CN', text: 'chinese' },
  { label: 'English', value: 'en', text: 'english' },
  { label: 'Italiano', value: 'it', text: 'italian' }, // 意大利语
  { label: 'Deutsch', value: 'de', text: 'german' }, // 德语
  { label: 'Español', value: 'es', text: 'spanish' }, // 西班牙语
  { label: 'Français', value: 'fr', text: 'french' }, // 法语
  { label: 'Hrvatska', value: 'hr', text: 'croatia' }, // 克罗地亚语
  { label: 'Slovenščina', value: 'sl', text: 'slovenia' }, // 斯洛文尼亚语
  { label: 'Magyar', value: 'hu', text: 'hungarian' }, // 匈牙利语
  { label: 'Serbian', value: 'sr', text: 'serbian' } // 塞尔维亚语
]



// WEBPACK FOOTER //
// ./src/utils/config.js